import React, { useEffect } from "react";
import { useState } from "react";
import DatePicker from "react-datepicker";
import {
  callingCode,
  Nationality,
  slashFormatter,
} from "../../../../helpers/helper";
import { useForm } from "../../../../hooks/useForm";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  flightBookAsync,
  getAirBookingStatus,
  getFareQuote,
  getFareRules,
  ResetLoader,
} from "../../../../features/bookings/flightSlice";
import {
  fetchCitywithCountry,
  getCountriesAsync,
  getCountryList,
} from "../../../../features/bookings/hotelSlice";
import SuccessModal from "../../../modals/SuccessModal";
import moment from "moment/moment";
import Loader from "../../../../helpers/Loader";

const FlightGuestForm = ({ fareRulesDetail }) => {
  const [guests, setGuests] = useState([]);
  const [leadPax, setLeadPax] = useState(0);
  const { Authorization } =
    JSON.parse(sessionStorage.getItem("userData")) || {};
  const fareQuote = useSelector(getFareQuote);
  const fareRules = useSelector(getFareRules);
  const dync = React.useRef([]);
  const countryList = useSelector(getCountryList);
  const bookingStatus = useSelector(getAirBookingStatus);

  useEffect(() => {
    dispatch(getCountriesAsync());
  }, []);

  const dispatch = useDispatch();
  const cityNames = useSelector((state) => state.hotel.cityNames, shallowEqual);

  const flightForm = JSON.parse(sessionStorage.getItem("flightForm")) || {};
  // const []
  const [status, setStatus] = useState("");
  const [msg, setMsg] = useState("");
  const [show, setShow] = useState(false);
  const [statusCode, setStatusCode] = useState("");
  const [bookLoader, setBookLoader] = useState(false);
  const statusCodes = useSelector((state) => state.flight.status, shallowEqual);
  const { adultsCount, childsCount, infantsCount, tripType, pickUp, dropOff } =
    flightForm || {};

  const [startDate, setStartDate] = useState(
    new Date().setFullYear(new Date().getFullYear() - 50)
  );
  const [endDate, setEndDate] = useState(
    new Date().setFullYear(new Date().getFullYear() - 5)
  );

  const fareBreakDown = fareQuote?.Result?.[0]?.FareBreakdown;
  const fare = fareQuote?.Result?.[0]?.Fare;

  // React.useEffect(() => {
  //   let success = [1, 2, 5, 8];
  //   if (Object?.keys(bookingStatus)?.length > 0) {
  //     if (success.includes(bookingStatus?.Status)) {
  //       setMsg(bookingStatus?.message);
  //       setStatus("Awesome!");
  //     } else {
  //       setMsg(bookingStatus?.message);
  //       setStatus("Failed!");
  //     }
  //     setShow(true);
  //   }
  // }, [bookingStatus]);

  useEffect(() => {
    // Object.keys(fareRules).length > 0 &&
    //   Object.keys(fareQuote).length > 0 &&
    //   dispatch(ResetLoader());
  }, [fareRules, fareQuote]);

  useEffect(() => {
    setBookLoader(false);
    if (bookingStatus === false) {
      if (parseInt(statusCodes) === 300) {
        setMsg("Your booking is under process.");
      } else {
        setMsg("Something went wrong try after sometime");
      }
      setShow(true);
      setStatusCode(statusCodes);
    }

    if (Object?.keys(bookingStatus).length > 0) {
      if (bookingStatus) {
        setStatusCode(statusCodes);
        setMsg(
          "Your booking has been Confirmed. Check your emails for details."
        );
        // setStatus("Awesome!");
      } else {
        if (parseInt(statusCodes) === 300) {
          setMsg("Your booking is under process.");
        } else {
          setMsg("Something went wrong try after sometime");
        }
        // setStatus("Failed!");
      }
      setShow(true);
    }
  }, [bookingStatus]);

  // let array = [];
  // fareBreakDown.forEach((ele) => array.push(([ele.PassengerType] = ele)));

  //  new Date(flightForm.state.DepartureDate).setFullYear(
  //   new Date(flightForm.state.DepartureDate).getFullYear() - 50
  // );

  const handleCityNames = (e) => {
    let name = JSON.parse(e.target.value).country_code || {};
    dispatch(fetchCitywithCountry({ name, Authorization }));
  };

  const TravellingDate =
    new Date(flightForm?.state?.DepartureDate).getTime() -
    new Date(flightForm?.state?.DepartureDate).getTimezoneOffset() * 60000;
  let arr = [];
  const customDyncValidate = (errors, ind, noSpCharsRegex) => {
    // guests.map((ele) => {
    // err[ind] = {};
    if (
      guests[ind]["IdType"] === "Passport" &&
      guests[ind]["IdNumber"].trim() !== ""
    ) {
      // err[ind]
      if (
        guests[ind]["IdNumber"].length < 6 ||
        guests[ind]["IdNumber"].length > 15 ||
        guests[ind]["IdNumber"].includes(" ") ||
        noSpCharsRegex.test(guests[ind]["IdNumber"])
      ) {
        errors.IdNumber = "Invalid passport number!";
      } // else
    }

    if (String(guests[ind]["IdNumber"]).trim() !== "") {
      if (!arr.includes(guests[ind]["IdNumber"])) {
        arr.push(guests[ind]["IdNumber"]);
      } else if (arr.includes(guests[ind]["IdNumber"])) {
        errors.IdNumber = "ID number must be unique!";
      }
    }

    if (guests[ind]["FirstName"].trim() !== "") {
      if (guests[ind]["FirstName"].length < 3) {
        errors.FirstName = "First name should be minimum 3 charachters!";
      }
    }

    if (guests[ind]["LastName"].trim() !== "") {
      if (guests[ind]["LastName"].length < 3) {
        errors.LastName = "Last name should be minimum 3 charachters!";
      }
    }

    //temp

    // if (
    //   guests[ind]["IdType"].trim() === "" &&
    //   guests[ind]["IdNumber"].trim() === "" &&
    //   guests[ind]["IdIssueDate"].trim() === "" &&
    //   guests[ind]["IdExpiryDate"].trim() === "" &&
    //   (guests[ind].PassengerType === 2 || guests[ind].PassengerType === 3)
    // ) {
    //   //
    //   delete errors["IdType"];
    //   delete errors["IdNumber"];
    //   delete errors["IdIssueDate"];
    //   delete errors["IdExpiryDate"];
    // }

    return errors;
  };

  const flightTrackingToken = JSON.parse(
    sessionStorage.getItem("flightTrackingToken")
  );

  const flightResultId = JSON.parse(sessionStorage.getItem("flightResultId"));
  // let dync = ["abc"];

  const checkDyncValidate = (name, regex, e, obj, ind) => {
    if (
      name === "IdNumber" &&
      e.target.value.trim() !== "" &&
      guests[ind].IdType === "Passport"
    ) {
      if (
        e.target.value.length < 6 ||
        e.target.value.length > 15 ||
        e.target.value.includes(" ") ||
        regex.test(e.target.value)
      ) {
        obj[name] = "Invalid Passport Number!";
      } else {
        // alert(199)
        delete obj[name];
      }
    } else {
      // alert(202)
      obj[name] !== undefined && delete obj[name];
    }

    let arr = [];
    guests.map((ele, index) => {
      if (String(ele.IdNumber).trim() !== "") {
        if (index !== ind) {
          arr.push(ele.IdNumber);
        }
      }
    });

    if (String(guests[ind].IdNumber).trim() !== "") {
      if (arr.includes(guests[ind]["IdNumber"])) {
        obj[name] = "ID Number Must Be Unique!";
      } else {
        // alert(220)
        obj === undefined && delete obj[name];
      }
      // if (!dync.current.includes(guests[ind]["IdNumber"])) {
      //   dync.current.push(guests[ind]["IdNumber"]);
      // } else if (dync.current.includes(guests[ind]["IdNumber"])) {
      //   obj[name] = "ID Number Must Be Unique!";
      // } else {
      //   delete obj[name];
      // }
    } else {
      // alert(228)
      delete obj[name];
    }

    //temp

    // if (
    //   guests[ind]["IdType"].trim() === "" &&
    //   guests[ind]["IdNumber"].trim() === "" &&
    //   guests[ind]["IdIssueDate"].trim() === "" &&
    //   guests[ind]["IdExpiryDate"].trim() === "" &&
    //   (guests[ind].PassengerType === 2 || guests[ind].PassengerType === 3)
    // ) {
    //   delete obj["IdType"];
    //   delete obj["IdNumber"];
    //   delete obj["IdIssueDate"];
    //   delete obj["IdExpiryDate"];
    // }

    if (guests[ind].FirstName.trim() !== "") {
      if (guests[ind].FirstName.length < 3) {
        obj[name] = "FirstName Should be Minimum 3 Charachters!";
      } else {
        // alert("in elese")
        delete obj[name];
      }
    }

    if (guests[ind].LastName.trim() !== "") {
      if (guests[ind].LastName.length < 3) {
        obj[name] = "LastName Should be Minimum 3 Charachters!";
      } else {
        delete obj[name];
      }
    }

    return obj;
  };

  const {
    state,
    setState,
    isSubmit,
    formErrors,
    handleInputChange,
    handleFormSubmit,
    checkErrors,
    handleInputDynamic,
    checkDyncErrors,
  } = useForm({
    val: {
      Email: "",
      MobileNo: "",
      CountryCode: "",
      Nationality: "",
      City: "",
      Address: "",
    },
    dyncVals: {
      items: guests,
      setItems: setGuests,
      arrItems: [
        "Title",
        "FirstName",
        "LastName",
        "Gender",
        "Dob",
        "IdType",
        "IdNumber",
        "IdIssueDate",
        "IdExpiryDate",
      ],
    },
    inDyncValidate: customDyncValidate,
    inDyncCheckValidate: checkDyncValidate,
    // dyncNames: "IdType",
  });

  const handleDatePicker = (e, ind, name) => {
    let myDate = new Date(e.getTime() - e.getTimezoneOffset() * 60000)
      .toISOString()
      .split("T")[0];

    let update = guests;

    if (guests !== undefined && guests !== null) {
      update[ind][name] = myDate;
      let arr = [
        ...guests.slice(0, ind),
        update[ind],
        ...guests.slice(ind + 1),
      ];
      setGuests(arr);
    }
    delete formErrors?.[ind]?.[name];
  };

  const setMinDOB = (type) => {
    switch (parseInt(type)) {
      case 1:
        return new Date().setFullYear(new Date().getFullYear() - 100);
        break;
      case 2:
        return new Date().setFullYear(new Date().getFullYear() - 13);
        break;
      case 3:
        return new Date().setFullYear(new Date().getFullYear() - 2);
        break;
    }
  };

  const setMaxDOB = (type) => {
    switch (parseInt(type)) {
      case 1:
        return new Date().setFullYear(new Date().getFullYear() - 12);
        break;
      case 2:
        return new Date().setFullYear(new Date().getFullYear() - 2);
        break;
      case 3:
        return new Date().setFullYear(new Date().getFullYear());
        break;
    }
  };

  useEffect(() => {
    let arr = [];

    if (fareQuote?.ValidDocumentTypes !== undefined) {
      for (let index = 0; index < adultsCount; index++) {
        arr.push({
          FirstName: "",
          LastName: "",
          PassengerType: 1,
          Title: "",
          Type: "Adult",
          Gender: "",
          Dob: "",

          // FirstName: "Viran",
          // LastName: "jain",
          // PassengerType: 1,
          // Title: "Mr",
          // Type: "Adult",
          // Gender: "1",
          // Dob: "1996-12-05",

          IdType:
            Object?.keys(fareQuote?.ValidDocumentTypes)?.length > 0 ? "" : null,
          IdNumber:
            Object?.keys(fareQuote?.ValidDocumentTypes)?.length > 0 ? "" : null,
          IdIssueDate:
            Object?.keys(fareQuote?.ValidDocumentTypes)?.length > 0 ? "" : null,
          IdExpiryDate:
            Object?.keys(fareQuote?.ValidDocumentTypes)?.length > 0 ? "" : null,
        });
      }

      for (let index = 0; index < childsCount; index++) {
        arr.push({
          FirstName: "",
          LastName: "",
          PassengerType: 2,
          Title: "",
          Type: "Child",
          Gender: "",
          Dob: "",
          IdType:
            Object?.keys(fareQuote?.ValidDocumentTypes)?.length > 0 ? "" : null,
          IdNumber:
            Object?.keys(fareQuote?.ValidDocumentTypes)?.length > 0 ? "" : null,
          IdIssueDate:
            Object?.keys(fareQuote?.ValidDocumentTypes)?.length > 0 ? "" : null,
          IdExpiryDate:
            Object?.keys(fareQuote?.ValidDocumentTypes)?.length > 0 ? "" : null,
        });
      }

      for (let index = 0; index < infantsCount; index++) {
        arr.push({
          FirstName: "",
          LastName: "",
          PassengerType: 3,
          Title: "",
          Type: "Infant",
          Gender: "",
          Dob: "",
          IdType:
            Object?.keys(fareQuote?.ValidDocumentTypes)?.length > 0 ? "" : null,
          IdNumber:
            Object?.keys(fareQuote?.ValidDocumentTypes)?.length > 0 ? "" : null,
          IdIssueDate:
            Object?.keys(fareQuote?.ValidDocumentTypes)?.length > 0 ? "" : null,
          IdExpiryDate:
            Object?.keys(fareQuote?.ValidDocumentTypes)?.length > 0 ? "" : null,
        });
      }
      setGuests(arr);
    }
    // setGuests([
    //   {
    //     FirstName: "Viran",
    //     LastName: "jain",
    //     PassengerType: 1,
    //     Title: "Mr",
    //     Type: "Adult",
    //     Gender: "1",
    //     Dob: "1996-12-05",
    //     IdType: "Passport",
    //     IdNumber: "Ama2566",
    //     IdIssueDate: "2005-08-30",
    //     IdExpiryDate: "2027-05-25",
    //   },
    //   {
    //     FirstName: "Ajit",
    //     LastName: "Khan",
    //     PassengerType: 1,
    //     Title: "Mr",
    //     Type: "Adult",
    //     Gender: "1",
    //     Dob: "1998-12-05",
    //     IdType: "Passport",
    //     IdNumber: "Ajit2559",
    //     IdIssueDate: "2009-08-30",
    //     IdExpiryDate: "2025-05-25",
    //   },
    //   {
    //     FirstName: "Hiren",
    //     LastName: "SHah",
    //     PassengerType: 2,
    //     Title: "Mr",
    //     Type: "Child",
    //     Gender: "1",
    //     Dob: "2003-12-05",
    //     IdType: "Passport",
    //     IdNumber: "Hiren2566",
    //     IdIssueDate: "2009-10-30",
    //     IdExpiryDate: "2027-06-27",
    //   },
    //   {
    //     FirstName: "AKhil",
    //     LastName: "John",
    //     PassengerType: 3,
    //     Title: "Mr",
    //     Type: "Infant",
    //     Gender: "1",
    //     Dob: "2017-09-10",
    //     IdType: "Passport",
    //     IdNumber: "Amil2556",
    //     IdIssueDate: "2017-10-07",
    //     IdExpiryDate: "2030-05-27",
    //   },
    // ]);
    dispatch(ResetLoader());
  }, [fareQuote]);

  const getFarePerAmount = (type) => {
    var obj = {};
    fareBreakDown.map((ele) => {
      if (parseInt(ele.PassengerType) === parseInt(type)) {
        obj = {
          TotalFare: ele.TotalFare / ele.PassengerCount,
          FareType: "PUB",
          AgentMarkup: ele.AgentMarkup / ele.PassengerCount,
          OtherCharges: ele.OtherCharges / ele.PassengerCount,
          CreditCardCharge: ele.CreditCardCharge / ele.PassengerCount,
          AgentPreferredCurrency: "USD",
          ServiceFee: ele.ServiceFee / ele.PassengerCount,
          BaseFare: ele.BaseFare / ele.PassengerCount,
          Tax: ele.Tax / ele.PassengerCount,
          PenaltyAmount: ele.PenaltyAmount / ele.PassengerCount,
          TaxBreakUpList: null,
        };
      }
    });
    return obj;
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      const { country_code, name } = JSON.parse(state.Nationality);
      let Passenger = [];
      guests.map((ele, ind) => {
        Passenger.push({
          Title: ele.Title,
          FirstName: ele.FirstName,
          LastName: ele.LastName,
          Gender: parseInt(ele.Gender),
          IsLeadPax: parseInt(leadPax) === ind,
          Type: ele.PassengerType,
          AddressLine1: state.Address,
          AddressLine2: state.Address,
          Email: state.Email,
          Mobile1: state.MobileNo,
          Mobile1CountryCode: state.CountryCode,
          Mobile2: null,
          Nationality: {
            CountryCode: country_code,
            CountryName: name,
          },
          Country: {
            CountryCode: country_code,
            CountryName: name,
          },
          City: {
            CountryCode: country_code,
            CountryName: name,
            CityCode: JSON.parse(state.City).city_code,
            CityName: JSON.parse(state.City).name,
          },
          DateOfBirth: new Date(ele.Dob).toISOString().split(".")[0],
          Meal: {
            Code: null,
            Description: null,
          },
          Seat: null,
          Fare: getFarePerAmount(ele.PassengerType),
          FFAirline: null,
          FFNumber: null,
          PaxBaggage: [],
          PaxMeal: [],
          PaxSeat: null,
          Ticket: null,
          PassengerIdType:
            ele.PassengerType === 1
              ? ele.IdType
              : ele.IdType.trim() !== ""
              ? ele.IdType
              : null,
          PassengerIdNo:
            ele.PassengerType === 1
              ? ele.IdNumber
              : ele.IdNumber.trim() !== ""
              ? ele.IdNumber
              : null,
          PassengerIdExpiry:
            ele.IdType === null || ele.IdType === undefined
              ? null
              : ele.PassengerType !== 1
              ? ele.IdExpiryDate.trim() !== ""
                ? new Date(ele.IdExpiryDate).toISOString().split("T")[0]
                : null
              : new Date(ele.IdExpiryDate).toISOString().split("T")[0],

          PassengerIdIssueDate:
            ele.IdType === null || ele.IdType === undefined
              ? null
              : ele.PassengerType !== 1
              ? ele.IdIssueDate.trim() !== ""
                ? new Date(ele.IdIssueDate).toISOString().split("T")[0]
                : null
              : new Date(ele.IdIssueDate).toISOString().split("T")[0],
          PassengerIdIssueCountryCode:
            ele.IdType === null || ele.IdType === undefined
              ? null
              : ele.PassengerType === 1
              ? country_code
              : country_code.trim() !== ""
              ? country_code
              : null,
        });
      });

      const {
        NonRefundable,
        FareRules,
        AirlineRemark,
        LastTicketDate,
        TicketAdvisory,
        ValidatingAirline,
        IsLcc,
        ProviderRemarks,
        ResponseTime,
        Origin,
        Destination,
        Segments,
      } = fareQuote?.Result?.[0];

      const { Airline } = fareRules?.FareRules?.[0]?.[0];
      setBookLoader(true);
      dispatch(
        flightBookAsync({
          Authorization,
          guests,
          ResultId: flightResultId,
          TokenId: flightTrackingToken.flightTokenId,
          TrackingId: flightTrackingToken.flightTrackingId,
          Passenger,
          NonRefundable,
          FareRules,
          AirlineRemark,
          LastTicketDate,
          TicketAdvisory,
          ValidatingAirline,
          Airline,
          JourneyType: tripType,
          IsLcc,
          ProviderRemarks,
          ResponseTime,
          Origin,
          Destination,
          Segments: Segments,
          TravelDate: new Date(flightForm.state.DepartureDate)
            .toISOString()
            .split(".")[0],
          SearchType: tripType,
          StaffRemarks: "",
          CreatedOn: new Date().toISOString().split("T")[0],
          AgentRefNo: null,
          IsDomestic:
            flightForm.state.pickUp.countryname ===
            flightForm.state.dropOff.countryname,
          PointOfSale: flightForm.state.pickUp.countrycode,
          RequestOrigin: flightForm.state.pickUp.countryname,
          EarnedLoyaltyPoints: "",
          ValidatingAirlineCode: Airline,
          UserData: Passenger[0]?.FirstName,
          fare,
          fareRulesDetail,
        })
      );
    }
  }, [formErrors, isSubmit]);

  const handleLeadPax = (e) => {
    setLeadPax(e.target.value);
  };

  if (bookLoader) {
    return <Loader />;
  }

  return (
    <>
      <div className="review-booking-wrapper guest-details-wrapper">
        <form action="" className="guest-detail-form flight-form-details">
          {/*  */}
          {guests.map((ele, ind) => {
            return (
              <div key={ind}>
                <h5 className="">
                  Guest {ind + 1} <span>{ele.Type}</span>
                </h5>
                {ele.PassengerType === 1 && (
                  <div className="select-type">
                    <label>
                      <input
                        type="radio"
                        // defaultChecked={ind === 0}
                        onChange={handleLeadPax}
                        checked={leadPax == ind}
                        name="Lead"
                        value={ind}
                        id={ind}
                      />
                      <span>Is Lead Passenger</span>
                    </label>

                    {/*
                    <span>
                      <input
                        type="radio"
                        // defaultChecked={ind === 0}
                        onChange={handleLeadPax}
                        checked={leadPax == ind}
                        name="Lead"
                        value={ind}
                        id={ind}
                      />
                      <label htmlFor={ind}>Is Lead Passenger</label>
                    </span>
                    */}
                  </div>
                )}

                <div className="name-detail flex-wrap shadow-none">
                  <div className="row">
                    <div className="col-lg-2">
                      <div className="form-group title-wrap position-relative">
                        <div className="select-arrow"></div>
                        <label htmlFor="">Title</label>
                        <select
                          name="Title[]"
                          className="form-control"
                          onChange={(e) => handleInputDynamic(ind, e)}
                          onBlur={(e) => checkDyncErrors(ind, e)}
                          autoComplete="off"
                        >
                          <option value="">Title</option>
                          <option value="Mr">Mr</option>
                          <option value="Ms">Ms</option>
                          <option value="Mrs">Mrs</option>
                        </select>
                        <span className="error">{formErrors[ind]?.Title}</span>
                      </div>
                    </div>
                    <div className="col-lg-5">
                      <div className="form-group">
                        <label htmlFor="">First Name</label>
                        <input
                          type="text"
                          placeholder="Enter First Name"
                          name="FirstName[]"
                          onChange={(e) => handleInputDynamic(ind, e)}
                          onBlur={(e) => checkDyncErrors(ind, e)}
                          autoComplete="off"
                        />
                        <span className="error">
                          {formErrors[ind]?.FirstName}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-5">
                      <div className="form-group">
                        <label htmlFor="">Last Name</label>
                        <input
                          type="text"
                          placeholder="Enter Last Name"
                          name="LastName[]"
                          onChange={(e) => handleInputDynamic(ind, e)}
                          autoComplete="off"
                          onBlur={(e) => checkDyncErrors(ind, e)}
                        />
                        <span className="error">
                          {formErrors[ind]?.LastName}
                        </span>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="">Date of birth</label>
                        <DatePicker
                          onChange={(e) => handleDatePicker(e, ind, "Dob")}
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          minDate={setMinDOB(ele.PassengerType)}
                          maxDate={setMaxDOB(ele.PassengerType)}
                          selected={Date.parse(ele.Dob)}
                          value={ele.Dob !== "" ? slashFormatter(ele.Dob) : ""}
                          dateFormat="YYYY-MM-DD"
                          name="Dob[]"
                          placeholderText="Date Of Birth"
                          onBlur={(e) => checkDyncErrors(ind, e)}
                          className="form-control"
                          style={{ Zindex: "100" }}
                        />
                        <span className="error">{formErrors[ind]?.Dob}</span>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form-group position-relative">
                        <div className="select-arrow"></div>
                        <label htmlFor="">Gender</label>
                        <select
                          name="Gender[]"
                          onChange={(e) => handleInputDynamic(ind, e)}
                          onBlur={(e) => checkDyncErrors(ind, e)}
                        >
                          <option value="">Select Gender</option>
                          {["Male", "Female"].map((ele, ind) => (
                            <option value={ind + 1} key={ind}>
                              {ele}
                            </option>
                          ))}
                        </select>
                        <span className="error">{formErrors[ind]?.Gender}</span>
                      </div>
                    </div>
                    {Object?.keys(fareQuote?.ValidDocumentTypes)?.length >
                      0 && (
                      <>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="">ID Type</label>
                            <select
                              name="IdType[]"
                              className="form-control"
                              onChange={(e) => handleInputDynamic(ind, e)}
                              onBlur={(e) =>
                                checkDyncErrors(ind, e, ele.PassengerType)
                              }
                              autoComplete="off"
                            >
                              <option value="">Select ID Type</option>
                              {fareQuote?.ValidDocumentTypes !== undefined &&
                                Object?.keys(fareQuote?.ValidDocumentTypes).map(
                                  (ele) => {
                                    if (
                                      fareQuote?.ValidDocumentTypes[ele] ===
                                      true
                                    ) {
                                      return (
                                        <option value={ele} key={ind}>
                                          {ele}
                                        </option>
                                      );
                                    }
                                  }
                                )}
                            </select>
                            <span className="error">
                              {formErrors[ind]?.IdType}
                            </span>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="">ID Number</label>
                            <input
                              type="text"
                              placeholder="Enter ID Number"
                              name="IdNumber[]"
                              onChange={(e) => handleInputDynamic(ind, e)}
                              autoComplete="off"
                              onBlur={(e) =>
                                checkDyncErrors(ind, e, ele.PassengerType)
                              }
                            />
                            <span className="error">
                              {formErrors[ind]?.IdNumber}
                            </span>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="">ID IssueDate</label>
                            <DatePicker
                              onChange={(e) =>
                                handleDatePicker(e, ind, "IdIssueDate")
                              }
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              minDate={
                                ele.Dob !== "" && Date.parse(new Date(ele.Dob))
                              }
                              maxDate={
                                new Date(
                                  moment(TravellingDate).subtract(3, "months")
                                )
                              }
                              selected={Date.parse(ele.IdIssueDate)}
                              value={
                                ele.IdIssueDate !== ""
                                  ? slashFormatter(ele.IdIssueDate)
                                  : ""
                              }
                              dateFormat="YYYY-MM-DD"
                              name="IdIssueDate[]"
                              placeholderText="Issue Date"
                              onBlur={(e) =>
                                checkDyncErrors(ind, e, ele.PassengerType)
                              }
                              className="form-control"
                              style={{ Zindex: "100" }}
                            />
                            <span className="error">
                              {formErrors[ind]?.IdIssueDate}
                            </span>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="">ID ExpiryDate</label>
                            <DatePicker
                              onChange={(e) =>
                                handleDatePicker(e, ind, "IdExpiryDate")
                              }
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              minDate={
                                new Date(
                                  moment(TravellingDate)
                                    .add(6, "months")
                                    .format("YYYY-MM-DD")
                                )
                              }
                              maxDate={
                                new Date(
                                  moment(TravellingDate)
                                    .add(10, "years")
                                    .format("YYYY-MM-DD")
                                )
                              }
                              selected={Date.parse(ele.IdExpiryDate)}
                              value={
                                ele.IdExpiryDate !== ""
                                  ? slashFormatter(ele.IdExpiryDate)
                                  : ""
                              }
                              dateFormat="YYYY-MM-DD"
                              name="IdExpiryDate[]"
                              placeholderText="Expire Date"
                              onBlur={(e) =>
                                checkDyncErrors(ind, e, ele.PassengerType)
                              }
                              className="form-control"
                              style={{ Zindex: "100" }}
                            />
                            <span className="error">
                              {formErrors[ind]?.IdExpiryDate}
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            );
          })}

          <div className="row">
            <div className="col-lg-12">
              <div className="form-group my-4">
                <label htmlFor="">
                  Email Address{" "}
                  <span className="medium14">
                    (Your booking voucher will be sent to this email address)
                  </span>
                </label>
                <input
                  type="Email"
                  placeholder="Enter Email Address"
                  autoComplete="off"
                  name="Email"
                  value={state.Email}
                  onChange={handleInputChange}
                  onBlur={(e) => checkErrors(e)}
                />
                <span className="error">{formErrors?.Email}</span>
              </div>
            </div>
          </div>

          <div className="name-detail mobile-number flex-wrap w-100">
            <div className="row w-100">
              <div className="col-lg-12">
                <div className="form-group">
                  <label for="">Mobile Number </label>
                  <div>
                    <div className="position-relative select-country-code">
                      <div className="select-arrow"></div>
                      <select
                        name="CountryCode"
                        className="form-control"
                        // onFocus={(e) => setErrors(e)}
                        autoComplete="off"
                        // onBlur={(e) => setSingleError(e)}
                        onBlur={(e) => checkErrors(e)}
                        onChange={handleInputChange}
                      >
                        <option value="">code</option>
                        {callingCode.map((ele, ind) => (
                          <option key={ind} value={ele.value}>
                            {ele.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    <input
                      type="text"
                      placeholder="Enter Mobile Number"
                      name="MobileNo"
                      value={state.MobileNo}
                      onChange={handleInputChange}
                      autoComplete="off"
                      onBlur={(e) => checkErrors(e)}
                      // onFocus={(e) => setErrors(e)}
                      // onBlur={(e) => setSingleError(e)}
                    />
                    <br />
                  </div>
                  <span className="error">{formErrors?.MobileNo}</span>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group position-relative">
                  <div className="select-arrow"></div>
                  <label htmlFor="">Nationality</label>
                  <select
                    name="Nationality"
                    onChange={(e) => {
                      handleInputChange(e);
                      handleCityNames(e);
                    }}
                    onBlur={(e) => checkErrors(e)}
                  >
                    <option value="">Select Nationality</option>
                    {countryList?.length > 0 &&
                      countryList.map((ele, ind) => (
                        <option key={ind} value={JSON.stringify(ele)}>
                          {ele.name}
                        </option>
                      ))}
                  </select>
                  <p className="error">{formErrors?.Nationality}</p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group position-relative">
                  <div className="select-arrow"></div>
                  <label htmlFor="">City</label>
                  <select
                    name="City"
                    onChange={handleInputChange}
                    onBlur={(e) => checkErrors(e)}
                  >
                    <option value="">Select City</option>
                    {cityNames !== undefined &&
                      cityNames?.length > 0 &&
                      cityNames.map((ele, ind) => (
                        <option key={ind} value={JSON.stringify(ele)}>
                          {ele.name}
                        </option>
                      ))}
                  </select>
                  <p className="error">{formErrors?.City}</p>
                </div>
              </div>
              <div className="col-lg-6"></div>
            </div>

            {/*  */}

            {/*  */}
          </div>
          {/*  */}
          <div className="form-group my-4">
            <label htmlFor="">Address: </label>
            <input
              type="Address"
              placeholder="Enter Your Address"
              autoComplete="off"
              name="Address"
              value={state.Address}
              onChange={handleInputChange}
              onBlur={(e) => checkErrors(e)}
            />
            <span className="error">{formErrors?.Address}</span>
          </div>

          {/*  */}
        </form>
      </div>

      {show ? (
        <SuccessModal
          setShow={setShow}
          show={show}
          msg={msg}
          status={status}
          statusCode={statusCode}
        />
      ) : null}

      <div>
        <button
          onClick={handleFormSubmit}
          className="cmn-btn reserve-btn d-block w-100"
        >
          Proceed To Payment
        </button>
      </div>
    </>
  );
};

export default FlightGuestForm;
